import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDialog, {
    attrs: { "data-qa": "search-modal", value: _vm.value, size: "fullscreen" },
    on: {
      input: function ($event) {
        return _setup.emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "extension",
        fn: function () {
          return [
            _c(
              VForm,
              {
                staticClass: "d-flex align-center",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _setup.handleSubmitForm.apply(null, arguments)
                  },
                },
              },
              [
                _c(_setup.VTextField, {
                  ref: "textField",
                  staticClass: "search-dialog-input",
                  attrs: {
                    id: "search-field",
                    maxlength: _setup.MAX_QUERY_LENGTH,
                    type: "search",
                    height: 48,
                    dense: "",
                    solo: "",
                    flat: "",
                    "clear-icon": "ui-icon-close-not-a-circle",
                    placeholder: `Поиск в ${_setup.selectedCity.name_pred}`,
                    autofocus: "",
                    "full-width": "",
                    "hide-details": "",
                    clearable: "",
                  },
                  on: {
                    focus: _setup.handleFocusSearchInput,
                    "click:append-outer": _setup.handleSubmitForm,
                    "click:prepend-inner": function ($event) {
                      return _setup.emit("input", false)
                    },
                    "click:clear": function ($event) {
                      _setup.query = ""
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "prepend-inner",
                      fn: function () {
                        return [
                          _c(VImg, {
                            staticClass: "mr-1",
                            attrs: {
                              src: "/static/_v1/pd/favicons/favicon_32x32.png",
                              height: "20",
                              width: "20",
                              contain: "",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _setup.query,
                    callback: function ($$v) {
                      _setup.query = $$v
                    },
                    expression: "query",
                  },
                }),
                _vm._v(" "),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-2 px-3",
                    attrs: { small: "", text: "", color: "primary" },
                    on: { click: _setup.handleClickCancel },
                  },
                  [_vm._v("\n        Отмена\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  VBtn,
                  {
                    staticClass: "pl-2 pr-4",
                    attrs: { text: "", small: "", height: "28" },
                    on: {
                      click: function ($event) {
                        _setup.isVisibleCityModal = true
                      },
                    },
                  },
                  [
                    _c(
                      VIcon,
                      {
                        staticClass: "mr-2",
                        attrs: { size: "20", color: "icon-secondary" },
                      },
                      [_vm._v("\n          ui-icon-map-pin\n        ")]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.selectedCity.name) +
                        "\n      "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(_setup.CityModal, {
                  attrs: { "selected-city": _setup.selectedCity },
                  on: { "city:selected": _setup.onClickCity },
                  model: {
                    value: _setup.isVisibleCityModal,
                    callback: function ($$v) {
                      _setup.isVisibleCityModal = $$v
                    },
                    expression: "isVisibleCityModal",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function ({ xSpaceClass, counterXSpaceClass }) {
          return [
            _setup.query?.length >= _setup.MIN_QUERY_LENGTH
              ? _c(_setup.SearchResults, {
                  class: counterXSpaceClass,
                  attrs: {
                    query: _setup.query,
                    town: _setup.selectedCity,
                    "is-office-ip": _setup.context.is_office_ip,
                    "x-space-class": xSpaceClass,
                  },
                })
              : _c(
                  "div",
                  { staticClass: "text-body-1 text-secondary--text" },
                  [
                    _c(_setup.NavLinks, {
                      attrs: {
                        town: _setup.selectedCity,
                        "counter-x-space-class": counterXSpaceClass,
                        "x-space-class": xSpaceClass,
                      },
                    }),
                  ],
                  1
                ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }